const fields = ["title", "description", "quantity", "sales_price", "purchase_price", "discount", "surcharge", "unit_id", "offer_group_id", "pricing_role", "visible_to_customer", "alternative_group", "price_source", "price_dated_at"];
const identity = (row) => String(row.client_key || row.id);
const same = (a, b) => String(a ?? "") === String(b ?? "");

/** Three-way merge: unrelated changes are kept; competing edits require a choice. */
export function mergeOfferLines(base, local, remote, choices = {}) {
  const conflicts = [];
  const result = remote.map((row) => ({ ...row }));
  local.forEach((row) => {
    const key = identity(row);
    const previous = base.find((item) => identity(item) === key);
    const index = result.findIndex((item) => identity(item) === key);
    if (index < 0) {
      if (!previous) { result.push(row); return; }
      if (fields.every((field) => same(previous[field], row[field]))) return;
      const id = `${key}:deleted`;
      if (!choices[id]) conflicts.push({ id, title: row.title, field: "deleted", local: row.title, remote: "—" });
      if (choices[id] === "local") result.push({ ...row, id: undefined });
      return;
    }
    fields.forEach((field) => {
      if (previous && same(previous[field], row[field])) return;
      const current = result[index];
      const id = `${key}:${field}`;
      if (previous && !same(previous[field], current[field]) && !same(row[field], current[field])) {
        if (!choices[id]) conflicts.push({ id, title: row.title, field, local: row[field], remote: current[field] });
        if (choices[id] !== "local") return;
      }
      current[field] = row[field];
    });
  });
  return { items: result, conflicts };
}
